import React from 'react';
import { Spinner } from 'evergreen-ui';
import { createUseStyles } from 'react-jss';

// для того, чтобы спинер всегда был посередине. Если сломается, то убрать классНейм
const useStyles = createUseStyles({
  spinnerWrap: {
    display: 'grid',
    alignItems: 'center',
    height: '100%',
    '& circle': {
      stroke: (props) => props.color,
    },
  },
});

export default function SuspenseSpinner({ size = 150, color = null }) {
  const classes = useStyles({ color });
  return (
    <div className={classes.spinnerWrap}>
      <Spinner size={size} marginX="auto" marginY="auto" />
    </div>
  );
}
